__turbopack_context__.v({
  "aboutbox1": "Prefit-module__mr-Vha__aboutbox1",
  "aboutheading1": "Prefit-module__mr-Vha__aboutheading1",
  "aboutparagraph1": "Prefit-module__mr-Vha__aboutparagraph1",
  "aboutparagraph2": "Prefit-module__mr-Vha__aboutparagraph2",
  "acheivername": "Prefit-module__mr-Vha__acheivername",
  "acheivernamespecial": "Prefit-module__mr-Vha__acheivernamespecial",
  "acheiverrank": "Prefit-module__mr-Vha__acheiverrank",
  "acheiverrank1": "Prefit-module__mr-Vha__acheiverrank1",
  "acheiverrankspecial": "Prefit-module__mr-Vha__acheiverrankspecial",
  "active": "Prefit-module__mr-Vha__active",
  "announcebtn": "Prefit-module__mr-Vha__announcebtn",
  "branchBtn": "Prefit-module__mr-Vha__branchBtn",
  "captcha": "Prefit-module__mr-Vha__captcha",
  "cardBox": "Prefit-module__mr-Vha__cardBox",
  "checkboxcontent": "Prefit-module__mr-Vha__checkboxcontent",
  "classesborder": "Prefit-module__mr-Vha__classesborder",
  "contactheader": "Prefit-module__mr-Vha__contactheader",
  "content": "Prefit-module__mr-Vha__content",
  "dot": "Prefit-module__mr-Vha__dot",
  "facultyborder3": "Prefit-module__mr-Vha__facultyborder3",
  "formstar": "Prefit-module__mr-Vha__formstar",
  "greycolor": "Prefit-module__mr-Vha__greycolor",
  "heading3d": "Prefit-module__mr-Vha__heading3d",
  "imagee": "Prefit-module__mr-Vha__imagee",
  "invalidCheck2": "Prefit-module__mr-Vha__invalidCheck2",
  "mbtableheading": "Prefit-module__mr-Vha__mbtableheading",
  "nav-item": "Prefit-module__mr-Vha__nav-item",
  "nav-link": "Prefit-module__mr-Vha__nav-link",
  "nav-pills": "Prefit-module__mr-Vha__nav-pills",
  "nav-tabs": "Prefit-module__mr-Vha__nav-tabs",
  "normalbutton": "Prefit-module__mr-Vha__normalbutton",
  "normalbutton1": "Prefit-module__mr-Vha__normalbutton1",
  "normalbutton2": "Prefit-module__mr-Vha__normalbutton2",
  "normalbutton3": "Prefit-module__mr-Vha__normalbutton3",
  "pagemaintitle": "Prefit-module__mr-Vha__pagemaintitle",
  "paybill": "Prefit-module__mr-Vha__paybill",
  "program": "Prefit-module__mr-Vha__program",
  "redunderline": "Prefit-module__mr-Vha__redunderline",
  "redunderlinealink": "Prefit-module__mr-Vha__redunderlinealink",
  "sectioncontent": "Prefit-module__mr-Vha__sectioncontent",
  "sectionredtitle": "Prefit-module__mr-Vha__sectionredtitle",
  "sectionsubtitle": "Prefit-module__mr-Vha__sectionsubtitle",
  "sectiontitle": "Prefit-module__mr-Vha__sectiontitle",
  "sectiontitle1": "Prefit-module__mr-Vha__sectiontitle1",
  "show": "Prefit-module__mr-Vha__show",
  "tabactive": "Prefit-module__mr-Vha__tabactive",
  "table1": "Prefit-module__mr-Vha__table1",
  "tableheading": "Prefit-module__mr-Vha__tableheading",
  "tablepara": "Prefit-module__mr-Vha__tablepara",
  "tablescroll": "Prefit-module__mr-Vha__tablescroll",
  "tabletitle": "Prefit-module__mr-Vha__tabletitle",
  "tablinks": "Prefit-module__mr-Vha__tablinks",
  "tabscrollclass": "Prefit-module__mr-Vha__tabscrollclass",
  "tabsection": "Prefit-module__mr-Vha__tabsection",
  "ulclass": "Prefit-module__mr-Vha__ulclass",
  "ulliclass": "Prefit-module__mr-Vha__ulliclass",
  "ullispan": "Prefit-module__mr-Vha__ullispan",
  "whatsnewkeyanimation": "Prefit-module__mr-Vha__whatsnewkeyanimation",
});
